import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-learning-center-second-section-input',
  templateUrl: './learning-center-second-section-input.component.html',
  styleUrls: ['./learning-center-second-section-input.component.scss']
})
export class LearningCenterSecondSectionInputComponent implements OnInit {
  @Input() learningCenterForm: FormGroup;


  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '350px',
    maxHeight: 'auto',
    width: '100%',
    minWidth: '100%',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'th-sarabun', name: 'Sarabun' },
      { class: 'K2D', name: 'K2D' },
    ],
    uploadUrl: environment.URL + '/manage_admin/uploadImgaeContentArtical',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top'
  };

  constructor() { }

  ngOnInit(): void {
  }

  get CONTENT2_DETAIL() {
    return this.learningCenterForm.get('CONTENT2_DETAIL') as FormControl;
  }

}
